import {Component, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';

import * as _ from 'underscore';
import {MiscelaneaService} from '../../../../../shared/services/miscelanea.service';
import {Observable} from 'rxjs/Observable';
import {VnaPortalService} from '../../../vna_portal/services/vna-portal.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {VnaPortalConfigDataParserService} from '../../../vna_portal/services/vna-portal-config-data-parser.service';
import {ModalExtended} from 'ngx-dynamic-modal';
import { VarAssocValidator} from '../../../../../shared/reactForm-validators/varAssocValidator';
import {SelectVnaVarsComponent} from '../../../../../shared/components/select-vna-vars/select-vna-vars.component';


@Component({
  selector: 'app-external-callback',
  templateUrl: './external-callback.component.html',
  styleUrls: ['./external-callback.component.scss']
})
export class ExternalCallbackComponent extends ModalExtended implements OnInit {

    form: FormGroup;
    enabled: boolean = false;
    submitted: boolean = false;
    data: Object;
    urlVars: any = [];

    onExit(): void {
        this.applyCallback(1);
        this.close();
    }

    @ViewChild(SelectVnaVarsComponent) varsComponent: SelectVnaVarsComponent;

    constructor(private fb: FormBuilder, private portalHandler: VnaPortalService, private dataParser: VnaPortalConfigDataParserService, private miscHandler: MiscelaneaService, private alertHandler: AlertaService) {
        super();
        this.form = this.fb.group({
            http_method: new FormControl('', Validators.required),
            url: new FormControl('', Validators.required),
            http_headers: new FormControl('',VarAssocValidator),
            status_to_send: new FormControl(),
            responses_to_send: new FormControl(),
            active: new FormControl('0'),
            url_vars: this.fb.array([]),
            all_vna_vars: new FormControl('0'),
            all_extra_vars: new FormControl('0'),
            manual_var: new FormControl('')
        });
    }

    requestAutocompleteStatus = (text: string): Observable<any> => {
        return this.miscHandler.findAvailableStatus().map(
            (rows: Array<Object>) => {
                return rows.map( (o) => {
                    return o['status'];
                })
            }
        );
    };

    requestAutocompleteResponse = (text: string): Observable<any> => {
        return this.miscHandler.findAllPhonePossibleResponses({ 'provider' : this.data['portalService'].alias }, text);
    };

    addUrlVar(data: any){
        const varData = (data) ? data : {label : '', value: ''};
        const group = this.fb.group({
            label: varData['label'],
            value: varData['value'],
        });

        this.urlVars = this.form.get('url_vars') as FormArray;
        this.urlVars.push(group);
    }

    addManualVar(){
        if(this.form.value.manual_var.length == 0){
            this.alertHandler.addAlert('warning', 'You must write a var');
            return;
        }

        this.checkVnaVar(this.form.value.manual_var);
    }

    checkVnaVar(e: any): void {
        if(e instanceof Event){
            return;
        }

        this.urlVars = this.form.get('url_vars') as FormArray;
        const idx = this.urlVars.controls.findIndex( (o) => {
            return o.value.label == e;
        });

        if(idx >= 0){
            this.alertHandler.addAlert('warning', 'Var ' + e + ' already added');
            return;
        }

        this.addUrlVar({'label' : e, 'value' : '{{' + e + '}}'});
    }

    removeVar(i: number): void {
        this.urlVars.removeAt(i);
    }

    buildUrlFromSelectedVars(append: boolean = false): void {

        if(this.form.value.url.length == 0){
            this.alertHandler.addAlert('warning', 'You must write an url first');
            return;
        }

        let queryParams = new URLSearchParams();
        if(this.form.value.all_vna_vars){
            this.varsComponent.vars.forEach( (o) => {
                if(this.form.value.all_vna_vars == '1' && o['type'] == 'vna'){
                    queryParams.append(o['label'], '{{' + o['label'] + '}}');
                }
                if(this.form.value.all_extra_vars == '1' && o['type'] == 'extra'){
                    queryParams.append(o['label'], '{{' + o['label'] + '}}');
                }
            });
        }


        let data = this.form.value.url.split('?');
        let url = data[0];
        let currentQueryString = data[1];

        this.form.value.url_vars.forEach( (o: Object) => {
            queryParams.append(o['label'], o['value']);
        });

        let queryString = (append) ? currentQueryString + '&' + decodeURI(queryParams.toString()) : decodeURI(queryParams.toString());
        url = url + '?' + queryString;
        this.form.controls['url'].setValue(url);
    }

    createExternalCallback(): void {
        if(!this.form.valid){
            this.submitted = true;
            return;
        }
        this.enabled = true;
        let data = this.dataParser.getExternalCallbackParametersToSend(this.form.value);
        data['portal_pk'] = this.data['portalService'].pkPortal;
        data['service_pk'] = this.data['portalService'].pkService;
        if(this.data['portalService'].pkCamp){
            data['service_campaign_pk']=this.data['portalService'].pkCamp;
        }
        this.portalHandler.saveExternalCallback(data).subscribe(
                (result) => {
                    this.alertHandler.addAlert('success', 'External callback parameters have been saved successfully');
                    this.enabled = false;
                    this.onExit();
                },
                (error) => {
                    this.alertHandler.addAlert('error', 'An error ocurren when trying to update external callback config. Please try again later');
                    this.enabled = false;
                }
            )
    }


    updateExternalCallback(row):void {
        if(!this.form.valid){
            this.submitted = true;
            return;
        }
        this.enabled = true;
        let data = this.dataParser.getExternalCallbackParametersToSend(this.form.value);

        this.portalHandler.updateExternalCallback(row.pk,data).subscribe(
            (result) => {
                this.alertHandler.addAlert('success', 'External callback parameters have been updated successfully');
                this.enabled = false;
                this.onExit();
            },
            (error) => {
                this.alertHandler.addAlert('error', 'An error ocurren when trying to update external callback config. Please try again later');
                this.enabled = false;
            }
        )
    }

    ngOnInit() {

        if(this.data.hasOwnProperty('row')){
            this.form.controls['url'].setValue(this.data['row']['url']);
            this.form.controls['http_method'].setValue(this.data['row']['http_method']);
            this.form.controls['http_headers'].setValue(this.data['row']['http_headers']);
            this.form.controls['active'].setValue(this.data['row']['active']);

            if(_.isArray(this.data['row']['responses_to_send'])){
                this.form.controls['responses_to_send'].setValue(this.data['row']['responses_to_send'].map( (value) => { return { 'value' : value, 'display' : value} } ));
            }

            if(_.isArray(this.data['row']['status_to_send'])){
                this.form.controls['status_to_send'].setValue(this.data['row']['status_to_send'].map( (value) => { return { 'value' : value, 'display' : value} } ));
            }
        }

    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/external-callback/external-callback.component.ts